import Vue from 'vue'
import axios from 'axios'

$(() => {
  if (!$('#admin-cs-tickets_index').length) {
    return
  }

  // form.js-admin-cs-ticket-search配下のradio,checkbox,select,inputの入力内容が変更された場合は、formをsubmitするjquery実装
  $(document).on('change', 'form.js-admin-cs-ticket-search input, form.js-admin-cs-ticket-search select', function() {
    $(this).closest('form').submit();
  });
   
})